const requestTokens = {
  bindPromoCoupon: 'bindPromoCoupon',
  facebookSignin: 'facebookSignin',
  googleSignin: 'googleSignin',
  appleSignin: 'appleSignin',
  giftCard: 'giftCard',
  redeemCoupon: 'redeemCoupon',
  redeemGiftSubscription: 'redeemGiftSubscription',
  giftSubscription: 'giftSubscription',
  facebookSigninManualEmail: 'facebookSigninManualEmail',
  order: 'order',
  unsubscribe: 'unsubscribe',
  applyCouponForSubscription: 'applyCouponForSubscription',
  resubscribe: 'resubscribe',
  registration: 'registration',
  cardUpdate: 'cardUpdate',
  upgrade: 'upgrade',
  subscription: 'subscription',
  addressUpdate: 'addressUpdate',
  unpause: 'unpause',
  payPal: 'paypalToken',
  signin: 'signin',
} as const

export type RequestToken = keyof typeof requestTokens


export default requestTokens
